const linkActionMap = {
   "https://share.hsforms.com/1BeLwgM65T1qJOTX5rtuZig4056k": "click:click exp-inform",
   "https://share.hsforms.com/1zyjH_mKZQ22GRS7tQnIr-Q4056k": "click:click exp-inform",
   "https://share.hsforms.com/1mWcXQCFfS8azwyLwxKwnfA4056k": "click:click exp-obs4Ischia",
   "https://share.hsforms.com/18QOjUX_-R-OyIC6CXJUWAg4056k": "click:click exp-obs4Ischia",
   "https://share.hsforms.com/12xqnTynJTyex4P3RKdKSag4056k": "click:click exp-res7Ischia",
   "https://share.hsforms.com/1-CISwaaWQFeLb5chdA34WA4056k": "click:click exp-res7Ischia",
   "https://share.hsforms.com/1JWiBOt6uTHejSyWTfcxf0g4056k": "click:click exp-voluIschia",
   "https://share.hsforms.com/1GASA9V87Rk-SSsP6_Sh8Iw4056k": "click:click exp-voluIschia",
   "https://share.hsforms.com/179vsPyiKSiiqJ6j2jwCJyQ4056k": "click:click exp-reseaIschia",
   "https://share.hsforms.com/1Zn5vfV9OTCOltf3zfGaHQQ4056k": "click:click exp-reseaIschia",
   "https://share.hsforms.com/1PnpgI-doRES3lxhHKnhZHQ4056k": "click:click exp-adveKindred",
   "https://share.hsforms.com/1MzhIp-1PSPmxdpgJzKHXKQ4056k": "click:click exp-adveKindred",
   "https://share.hsforms.com/1XTMryQS8Q82rWVcEaKS8vg4056k": "click:click exp-explKindred",
   "https://share.hsforms.com/1TfzQCfH3T46ctCnl5Et9uw4056k": "click:click exp-explKindred",
   "https://share.hsforms.com/1oXb9F3mJSnmrg9MZtYbKUw4056k": "click:click exp-voluKindred",
   "https://share.hsforms.com/1-GzrPhbETOWqcAGx4LbjRQ4056k": "click:click exp-voluKindred",
   "https://share.hsforms.com/1_r3N8Aa1QWKl_5n577VhfQ4056k": "click:click exp-headAdvKindred",
   "https://share.hsforms.com/1_Qzl6oCgR2CUTCDdWvgFYw4056k": "click:click exp-headAdvKindred",
   "https://share.hsforms.com/1qYE4CEkIQaGSgdOijosnlw4056k": "click:click exp-headEladio",
   "https://share.hsforms.com/1wk_AtwZCT-q77CDD3W2L-g4056k": "click:click exp-headEladio",
   "https://share.hsforms.com/1vxoxDh0VQ8i-YjkwN7pOow4056k": "click:click exp-short4Eladio",
   "https://share.hsforms.com/1ctRfk4TPTWSIEk9B4UY6Ug4056k": "click:click exp-short4Eladio",
   "https://share.hsforms.com/11PU-141vTSSdzitsRpB5eQ4056k": "click:click exp-full7Eladio",
   "https://share.hsforms.com/1Nh48mW57RXm7DsufMpnLRw4056k": "click:click exp-full7Eladio",
   "https://share.hsforms.com/1EuZ2IOK_RrugjTSYmTsQ2Q4056k": "click:click exp-long30Eladio",
   "https://share.hsforms.com/1tsdpC5TCRY27Pge_CDMgOA4056k": "click:click exp-long30Eladio",
   "https://share.hsforms.com/1eF969ZDkSku5UmlSWL1oCg4056k": "click:click exp-diveSchnBali",
   "https://share.hsforms.com/1G8X2XYypSoiPgWd9xyuXLw4056k": "click:click exp-diveSchnBali",
   "https://share.hsforms.com/1Toe1kHuLSOm0gMrNAZ7ybw4056k": "click:click exp-certBali",
   "https://share.hsforms.com/1xz2dKTmnReaD6MjaDDTu0A4056k": "click:click exp-certBali",
   "https://share.hsforms.com/10MVXxTIjQOuL2mLe4mtwbw4056k": "click:click exp-full6Bali",
   "https://share.hsforms.com/1o75yDyW0TrmeuB5XgpS1xQ4056k": "click:click exp-full6Bali"
};

export const isTrackedLink = (href) => {
   if (href == null || href == undefined || href == '') {
       return {};
   }

   return { 'data-elbaction': linkActionMap[href] || '' };
}
